import React, { Component } from "react";
import Title from "../Title";
import CartColumns from "./CartColumns";
import CartList from "./CartList";
import CartTotals from "./CartTotals";
import { ProductConsumer } from "../../context";
import EmptyCart from "./EmptyCart";
import  SearchStudents from "./search";
export default class Store extends Component {

// Add a listener to prevent browser page refresh
componentWillMount() {
  onbeforeunload = e => "Don't leave"
}

// Clear listener
componentWillUnmount() {
  onbeforeunload = null
}



  render() {
    return (
      <section>
        <ProductConsumer>
          {value => {
            const { cart } = value;
 
            if (cart.length > 0) {
              return (
                <React.Fragment>
                  <Title name="student" title="cart" />
                  <CartColumns />
                  <CartList value={value} />
                  <CartTotals value={value} 
                  history={this.props.history} 
                  />

                <SearchStudents value={value}/>
                
                </React.Fragment>
              
            
              
              
              );
            } else {
              return <EmptyCart />;
            }
          }}
        </ProductConsumer>
      </section>
    );
  }
}